<template>
  <button class="btn btn--cta row items-center justify-center"
          type="button"
          :class="`btn--cta-${color}`"
          v-on="listeners"
  >
    <div class="arrow-wrap">
      <div class="arrow-tail"></div>
      <div class="arrow-tip"></div>
    </div>
    <span class="btn-text">
      <slot></slot>
    </span>
  </button>
</template>

<script>
export default {
  name: 'ButtonCTA',
  props: {
    color: {
      type: String,
      default: 'green',
    },
    to: {
      type: String,
    },
  },
  computed: {
    isLink() {
      return !!this.to;
    },
    listeners() {
      const { isLink, $listeners, handleLinkClick } = this;
      if (isLink) {
        return {
          ...$listeners,
          click: handleLinkClick,
        };
      }
      return $listeners;
    },
  },
  methods: {
    handleLinkClick() {
      const { to } = this;
      this.$router.push(to);
    },
  },
};
</script>

<style lang="stylus" scoped>
  @import '../styles/variables';

  .btn--cta{
    height: 80px;
    width: 240px;
    position: relative;
    font-size: 15px;
    line-height: 31px;
    font-weight: 400;
    padding: 0;
    cursor: pointer;
    transition: color 0.3s;
    overflow: hidden;

    .btn-text{
      position: relative;
    }

    &:focus{
      outline: none;
    }

    &:before{
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      transform: translateX(-100%);
      transition: transform 0.3s;
    }

    &:hover{
      &:before{
        transform: translateX(0);
      }
    }

    .arrow-wrap{
      margin-bottom: 0;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      .arrow-tail{
        transition: background 0.3s;
      }
      .arrow-tip{
        transition: border-color 0.3s;
      }
    }

    &.btn--cta-white{
      background: white;
      color: #4cb06a;
      .arrow-wrap{
        .arrow-tail{
          background: #4cb06a;
        }
        .arrow-tip{
          border-color: transparent transparent transparent #4cb06a;
        }
      }

      &:before{
        background: #4cb06a;
      }

      &:hover{
        color: white;

        .arrow-wrap{
          .arrow-tail{
            background: white;
          }
          .arrow-tip{
            border-color: transparent transparent transparent white;
          }
        }
      }
    }

    &.btn--cta-green{
      background: #4cb06a;
      color: white;
      .arrow-wrap{
        .arrow-tail{
          background: white;
        }
        .arrow-tip{
          border-color: transparent transparent transparent white;
        }
      }

      &:before{
        background: white;
      }

      &:hover{
        color: #4cb06a;

        .arrow-wrap{
          .arrow-tail{
            background:  #4cb06a;
          }
          .arrow-tip{
            border-color: transparent transparent transparent  #4cb06a;
          }
        }
      }
    }
  }
</style>
